import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const cosmosFlagCss = ":host{display:inline-block}img{display:block;height:100%;width:var(--cosmos-flag-width, 100%)}";
const CosmosFlagStyle0 = cosmosFlagCss;

const CosmosFlag$1 = /*@__PURE__*/ proxyCustomElement(class CosmosFlag extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.alt = '';
        this.code = undefined;
        this.loading = 'eager';
    }
    getFlagUrl() {
        return `https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-${this.code}.svg`;
    }
    render() {
        return (h(Host, null, h("img", { part: "base flag", src: this.getFlagUrl(), loading: this.loading, alt: this.alt })));
    }
    static get style() { return CosmosFlagStyle0; }
}, [1, "cosmos-flag", {
        "alt": [513],
        "code": [513],
        "loading": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-flag"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-flag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosFlag$1);
            }
            break;
    } });
}

const CosmosFlag = CosmosFlag$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosFlag, defineCustomElement };
